export default "__VITE_ASSET__X_RkYrJi__"